/**
 * <ClassInfoTD
 * 		classInfo={classInfo Object}
 *	/>
 *
 * @parent table in Student
 * @stateless
 */
import React, { PropTypes } from 'react';
import PaymentModal, { REFUND } from 'template/Modals/NewPayment';
import {confirm} from 'util/confirm'
import __R from 'containers/__R'
import { Link, browserHistory } from 'react-router'
import { Button } from "react-bootstrap"

class ClassInfoTD extends React.Component {
  constructor(props) {
		super(props);
	}

	static propTypes = {
		student: PropTypes.object,
		classInfo: PropTypes.object,
    exitClass: PropTypes.func.isRequired,
    enrollStudentToClass: PropTypes.func.isRequired,
	}
goToClassDetail() {
  let { classInfo } = this.props;
  let {classID, type } = classInfo;
  if(type === 0) {
    browserHistory.push(`/class-detail/${classID}`);
  }else {
    browserHistory.push(`/class-one-detail/${classID}`);
  }
}
	render() {
		let {
			student,
			classInfo,
			exitClass,
      enrollStudentToClass,
      userId
    } = this.props;

		if (!classInfo) {
      return (
        <__R can='assign_student_to_class' by='disable'>
          <Button className="btn-link" onClick={()=>{
            enrollStudentToClass();
          }}>{__("Join Class", "student")}</Button>
        </__R>
      )
		}

		let {classID, type, className, classTotalFee, paidTotalFee} = classInfo;

		return (
			<div className='class-info-container'>
				<div>
          <__R can="read_student_class" by='disable'>
            <button className="btn-link class-info-name" onClick={()=>this.goToClassDetail()}>{className}</button>
          </__R>
          <__R can='archive_student_from_class' by='disable'>
            <Button className="btn-link exit-class" onClick={()=>{
              if(paidTotalFee > 0){
                confirm(__('This student has paid tuition, do you wish to refund?', 'studentTable'))
                .then(() => {
                  PaymentModal({
                    student,
                    classInfo,
                    user_id: userId,
                    paymentType: REFUND,
                    confirmTitle: __('Refund & Exit Class', 'classdetail'),
                    confirmText: __('Proceed to refund and remove the student, {student_name}, from class?', 'classdetail', { student_name: student.sName }),
                  })
                  .then(()=>{
                    exitClass(classInfo, student);
                  })
                  .catch(() => {})
                })
                .catch(() => {
                  exitClass(classInfo, student);
                })
              } else {
                exitClass(classInfo, student);
              }
              }}>{__("Exit Class", "student")}
            </Button>
          </__R>
				</div>
        {/* { typeof classTotalFee !== 'undefined' &&
          <small>
					  ${classTotalFee}
          </small>
        } */}
			</div>
		);
  }
}

export default ClassInfoTD;



// WEBPACK FOOTER //
// ./src/containers/pages/Student/StudentTable/ClassInfoTd.js